export enum FirebaseError {
  AuthEmailAlreadyInUse = 'auth/email-already-in-use',
  AuthInvalidEmail = 'auth/invalid-email',
  AuthOperationNotAllowed = 'auth/operation-not-allowed',
  AuthUserDisabled = 'auth/user-disabled',
  AuthUserNotFound = 'auth/user-not-found',
  AuthWeakPassword = 'auth/weak-password',
  AuthWrongPassword = 'auth/wrong-password'
}
